<script setup>
import Buttons from '@/components/ui/Buttons.vue';
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <div
    v-if="data && (data?.text || data?.image || data?.button || data?.details)"
    :class="[
      backgroundColor
        ? `discount-system__wrap discount-system__wrap--${backgroundColor}`
        : 'discount-system__wrap',
    ]"
  >
    <div v-if="data?.image && data?.image?.src" class="discount-system__media">
      <NuxtImg
        v-if="data?.image?.src"
        class="discount-system__image"
        :src="data?.image?.src"
        :alt="data?.image?.alt"
        :height="data?.image?.height"
        :width="data?.image?.width"
        data-aos="zoom-in"
        data-aos-easing="ease-out-quad"
        loading="lazy"
      />
    </div>
    <div class="discount-system__content">
      <div
        v-if="data?.text"
        :class="[
          backgroundColor === 'black'
            ? 'discount-system__text body-1-regular white'
            : 'discount-system__text body-1-regular black',
        ]"
        data-aos="fade-up"
        data-aos-easing="ease-out-cubic"
        v-html="data?.text"
      ></div>
      <Buttons
        v-if="data.buttons && data.buttons.length > 0"
        class="discount-system__buttons"
        :buttons="data.buttons"
        :background-color="data?.background_color"
        data-aos="fade-up"
        data-aos-easing="ease-out-cubic"
        :buttons-prefix-class="'js-button-discount'"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.discount-system {
  $parent: &;
  &__wrap {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas: 'media' 'content';
    gap: 32px;
    @include media-breakpoint-up(sm) {
      gap: 48px;
    }
    @include media-breakpoint-up(md) {
      grid-template-columns: 5fr 7fr;
      grid-template-areas: 'content media';
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 48);
    }
    &--black {
      #{$parent} {
        &__content {
          border-color: $on-surface-variant-2;
        }
      }
    }
  }

  &__media {
    grid-area: media;
  }
  &__image {
    border-radius: 4px;
    height: auto;
    width: 100%;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 4);
    }
  }
  &__content {
    border-top: 1px solid $divider;
    display: flex;
    grid-area: content;
    flex-direction: column;
    gap: 24px;
    padding-top: 32px;
    @include media-breakpoint-up(sm) {
      gap: 40px;
      padding-top: 48px;
    }
    @include media-breakpoint-up(md) {
      border-right: 1px solid $divider;
      border-top: unset;
      padding: 0 16px 0 0;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 40);
      @include responsive-spacing(border-right-width, 1);
      @include responsive-spacing(padding-right, 16);
    }
  }
  &__text {
    &:deep(p:last-child) {
      margin-bottom: 0;
    }
    @include media-breakpoint-up(md) {
      padding-right: 32px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(padding-right, 32);
    }
  }
  &__buttons {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
    @include media-breakpoint-up(sm) {
      align-items: center;
      gap: 24px;
      flex-direction: row;
    }
    @include media-breakpoint-up(md) {
      margin-top: auto;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 24);
    }
  }
}
</style>
